import axios from "axios";
import PrefixPath from "../config/AppConfig";

const base = PrefixPath.LOCATION_API_BASE_URL;

export const getStates = () => axios.get(`${base}states`);
export const getCities = (state) =>
  axios.get(`${base}states/${state}/cities`);
export const getCommunities = (state, city) =>
  axios.get(`${base}states/${state}/cities/${city}/communities`);